<script setup lang="ts">
import { ref } from 'vue';

const step = ref(1);
const userType = ref<string | null>(null);

const selectUserType = (type: string) => {
    userType.value = type;
    step.value++;
};

const nextStep = () => {
    if (step.value < 4) step.value++;
};

const prevStep = () => {
    if (step.value > 1) step.value--;
};

const fastForward = () => {
    step.value = 4;
};
const backToStart = () => {
    step.value = 1;
}
</script>

<template>
    <div class='onboarding-container'>
        <div v-if="step === 1">
            <h2>Welcome to XYButterfly</h2>
            <p>What best describes you?</p>
            <button @click="selectUserType('individual')">Individual</button>
            <button @click="selectUserType('team')">Team</button>
            <button @click="selectUserType('organization')">Organization</button>
        </div>
        <div v-if="step === 2">
            <h2>About XYButterfly</h2>
            <p v-if="userType === 'individual'">Enhancing personal leadership and decision-making.</p>
            <p v-if="userType === 'team'">Tracking team progress and collaboration.</p>
            <p v-if="userType === 'organization'">Managing multiple teams with data-driven insights.</p>
            <button @click="prevStep">Back</button>
            <button @click="nextStep">Next</button>
        </div>
        <div v-if="step === 3">
            <h2>Key Features</h2>
            <ul>
                <li>Real-time feedback & insights</li>
                <li>Structured decision-making support</li>
                <li>Designed for flexibility & growth</li>
            </ul>
            <button @click="prevStep">Back</button>
            <button @click="nextStep">Next</button>
            <button @click="fastForward">Fast Forward</button>
        </div>
        <div v-if="step === 4">
            <h2>Get Started</h2>
            <p>Where would you like to begin?</p>
            <a href="https://demo.xybutterfly.com">Demo App</a>
            <a href="https://app.xybutterfly.com">Production App</a>
            <button @click="prevStep">Back</button>
            <button @click="backToStart">Back to Start</button>
        </div>
    </div>
</template>

<style scoped>
.onboarding-container {
    text-align: center;
    padding: 20px;
    background-color: black;
    height: 100%;
    
}
button {
    margin: 5px;
    padding: 10px 20px;
    border: none;
    background-color: #00965a;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;
}
button:hover {
    background-color: #007a48;
}
a {
    display: block;
    margin-top: 10px;
    color: #00b7ff;
    text-decoration: none;
}
a:hover {
    text-decoration: underline;
}
</style>
